import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { MarkdownContent } from './MarkdownContent'

interface Article {
  title: string
  content: string
  type: 'FAQ' | 'Contact' | 'Policy' | 'Legal'
  batchTag?: string
  tags?: string[]
}

interface ArticleModalProps {
  open: boolean
  onClose: () => void
  article?: Article
}

const ArticleModal: React.FC<ArticleModalProps> = ({ open, onClose, article }) => {
  if (!open || !article) return null

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose()
  }

  return (
    <div
      className="fixed inset-0 z-[1990] flex flex-col bg-black/50"
      onClick={handleOverlayClick}
    >
      <div
        className="h-full min-h-0 w-full max-h-none max-w-none rounded-none flex flex-col overflow-hidden bg-base-100 shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-start gap-3 border-b border-base-300/50 px-4 py-4 pt-5 sm:px-6">
          <div className="min-w-0 flex-1">
            <h2 className="text-xl font-bold sm:text-2xl">{article.title}</h2>
            {article.type === 'Policy' && (article.batchTag || article.tags?.length) ? (
              <div className="mt-2 flex flex-wrap gap-1.5">
                {article.batchTag ? (
                  <span className="badge badge-primary badge-outline">{article.batchTag}</span>
                ) : null}
                {article.tags?.map((t) => (
                  <span key={t} className="badge badge-ghost">
                    {t}
                  </span>
                ))}
              </div>
            ) : null}
          </div>
          <button
            type="button"
            className="btn btn-sm btn-circle btn-ghost shrink-0"
            aria-label="Close article"
            onClick={onClose}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-y-contain px-4 py-4 text-base-content sm:px-6">
          <MarkdownContent markdown={article.content} />
        </div>
      </div>
    </div>
  )
}

export default ArticleModal
